import React, { lazy, type FC, type ReactElement } from "react";
import { loadRemoteModule } from "@cw-elements/mfe-setup/load";
import { useConfig } from "@cw-elements/config";
import { ErrorBoundary } from "../../shared/components/ErrorBoundary";
import { useAppState } from "../../lib/appContext/AppContext";
import { useSafeNavigate } from "../../shared/custom-hooks/useSafeNavigate";
import { useTranslation } from "react-i18next";
import { appURLs } from "../../lib/appRoutes/appUrls";

const EntitiesHall = lazy(
  async () => await loadRemoteModule<any>("entities-hall/index")
);

export const EntitiesHallPlatform: FC = (): ReactElement => {
  const { setStateValue } = useAppState();
  const config = useConfig();
  const navigate = useSafeNavigate();
  const { i18n } = useTranslation();
  return (
    <ErrorBoundary>
      <EntitiesHall
        getConfigInstance={() => config}
        userLanguage={i18n.language}
        baseRoute={`${appURLs.MY_CROPWISE}`}
        history={history}
        onEntitySelection={(selectedEntities: any) => {
          if (selectedEntities.workspace && !selectedEntities.organization) {
            setStateValue((prevState: any) => ({
              ...prevState,
              workspaceValue: selectedEntities.workspace,
              orgValue: null,
              farmValue: null,
            }));
          }
          if (selectedEntities.organization && !selectedEntities.farm) {
            // Always set workspace_id on orgValue
            setStateValue((prevState: any) => ({
              ...prevState,
              orgValue: {
                ...selectedEntities.organization,
                workspace_id:
                  selectedEntities.workspace?.id ??
                  selectedEntities.organization?.workspace_id ??
                  selectedEntities.organization?.workspaces?.[0]?.id,
              },
              farmValue: null,
            }));
          }
          if (selectedEntities.farm) {
            setStateValue((prevState: any) => ({
              ...prevState,
              farmValue: selectedEntities.farm,
            }));
            const workspaceId: string =
              selectedEntities.workspace?.id ??
              selectedEntities.organization?.workspace_id ??
              selectedEntities.organization?.workspaces?.[0]?.id;
            const orgId: string = selectedEntities.organization?.id;
            navigate(
              `${appURLs.TRIALS}/workspace/${workspaceId}/org/${orgId}/farm/${
                selectedEntities.farm.id as string
              }`
            );
          }
        }}
        entityFeatureList={() => ({
          organization: [],
          farm: [],
        })}
        defaultConfig={{
          seasonFilter: "false",
          stopRedirect: "true",
        }}
      />
    </ErrorBoundary>
  );
};
